// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Recoil from "./recoil";

var RecoilRoot = {};

function atom(prim0, prim1) {
  return Recoil.atom(prim0, prim1);
}

export {
  RecoilRoot ,
  atom ,
}
/* ./recoil Not a pure module */
